// DL Fork: plugin configuration storage types
/**
 * DL Plugin Config System Types
 *
 * This module defines the plugin configuration storage system for DataLink BI.
 * It supports per-dashboard plugin configuration with a dedicated table structure.
 *
 * Each plugin has a unique identifier (e.g., 'dl_date_filter') and can store
 * its own configuration JSON per dashboard.
 */
/**
 * Plugin ID constant for the date filter plugin
 */
export const DL_DATE_FILTER_PLUGIN_ID = 'dl_date_filter';
//# sourceMappingURL=dlPluginConfig.js.map